// src/Home.js
import React, { useEffect, useState } from 'react';
import AnimateOnScroll from './../../components/common/animate';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Slider from 'react-slick';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
export default function About() {
    const [galleryItems, setgalleryItems] = useState([]);
    const [loading, setLoading] = useState(false);
   const [page, setPage] = useState([]);
 
 useEffect(() => {
  getPages();
    getImages();
  }, []);

  const getImages = () => {
    setLoading(true);
    DataService.getImages()
      .then((response) => {
        const gallery = [];
        for(var i=0; i<response.data.data.length ; i++) {
          gallery.push(response.data.data[i].url)
        }
        setgalleryItems(gallery);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
const getPages = (date) => {
   
    DataService.getPages(date)
      .then((response) => {

        let pages = response.data
        const about = pages.find(
          (page) => page.page_name === "About"
        );
        
       setPage(about);
       

      })
      .catch((error) => {
        console.error('Failed to fetch services:', error);
      })
      .finally();
  };
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 1500, // 3 seconds
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 1 },
      },
    ],
  };
  
  return (
     <>
      <LoaderOverlay loading={loading} />
    <div>
      <Helmet>
          {/* Primary Meta Tags */}
          <title>About Us | Divine Blush Beauty | Premier Beauty Salon in Regina SK</title>
          <meta name="title" content="About Us | Divine Blush Beauty | Premier Beauty Salon in Regina SK" />
          <meta name="description" content="Learn about Divine Blush Beauty, Regina's premier beauty salon. We offer expert facial treatments, waxing, makeup, and hair services exclusively for women. Discover our passion for beauty and commitment to excellence." />
          <meta name="keywords" content="about Divine Blush Beauty, best salon Regina SK, beauty salon Regina, professional beauty services Regina, women's salon Regina, beauty experts Regina Saskatchewan" />
          <meta name="robots" content="index, follow" />
          <link rel="icon" href="/favicon.ico" type="image/x-icon" />
          <link rel="canonical" href="https://www.divineblushbeauty.ca/about" />

          {/* Open Graph / Facebook */}
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.divineblushbeauty.ca/about" />
          <meta property="og:title" content="About Us | Divine Blush Beauty | Premier Beauty Salon in Regina SK" />
          <meta property="og:description" content="Learn about Divine Blush Beauty, Regina's premier beauty salon offering expert facial treatments, waxing, makeup, and hair services exclusively for women." />
          <meta property="og:image" content="https://www.divineblushbeauty.ca/images/about_img_banner.jpg" />
          <meta property="og:site_name" content="Divine Blush Beauty" />
          <meta property="og:locale" content="en_CA" />

          {/* Twitter */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:url" content="https://www.divineblushbeauty.ca/about" />
          <meta name="twitter:title" content="About Us | Divine Blush Beauty | Regina SK" />
          <meta name="twitter:description" content="Learn about Divine Blush Beauty, Regina's premier beauty salon offering expert beauty services for women." />
          <meta name="twitter:image" content="https://www.divineblushbeauty.ca/images/about_img_banner.jpg" />

          {/* Structured Data - Organization */}
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "BeautySalon",
                "name": "Divine Blush Beauty",
                "alternateName": "Divine Blush Beauty Regina",
                "url": "https://www.divineblushbeauty.ca",
                "logo": "https://www.divineblushbeauty.ca/images/Logo_salon.svg",
                "image": "https://www.divineblushbeauty.ca/images/about_img_banner.jpg",
                "description": "Divine Blush Beauty is Regina's premier beauty salon, specializing in professional facial treatments, waxing, makeup, and hair services exclusively for women.",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "3104, Crossbie Cres",
                  "addressLocality": "Regina",
                  "addressRegion": "SK",
                  "postalCode": "S4V3S2",
                  "addressCountry": "CA"
                },
                "geo": {
                  "@type": "GeoCoordinates",
                  "latitude": "50.4452",
                  "longitude": "-104.6189"
                },
                "telephone": "+1-639-915-0949",
                "priceRange": "$$",
                "servesCuisine": "Beauty Services",
                "areaServed": {
                  "@type": "City",
                  "name": "Regina",
                  "@id": "https://en.wikipedia.org/wiki/Regina,_Saskatchewan"
                }
              }
            `}
          </script>
        </Helmet>
  <section className="hero-wrap hero-wrap-2" style={{"background-image":"url('images/about_img_banner.jpg')"}} data-stellar-background-ratio="0.5">
    <div className="overlay" />
    <div className="container">
      <div className="row no-gutters slider-text js-fullheight align-items-center justify-content-center">
         <AnimateOnScroll className='col-md-9 text-center'>
            <h1 className="mb-3 bread">About</h1>
             <p className="breadcrumbs"><span className="mr-2"><Link to="/"> Home
                       </Link></span> <span>About</span></p>
         </AnimateOnScroll>
        
      </div>
    </div>
  </section>
  <section className="ftco-section ftco-intro" style={{"background-image":"url(images/intro.jpg)"}}>
    <div className="container">
      <div className="row justify-content-end">
        <div className="col-md-6">
             <AnimateOnScroll className='heading-section'>
                    <h2 className="mb-4">About Divine Blush Beauty</h2>
             </AnimateOnScroll>
          <AnimateOnScroll>
{page?.message && (
                  <div
                    dangerouslySetInnerHTML={{ __html: page.message }}
                  />
                )}
          </AnimateOnScroll>
        
          <ul className="mt-5 do-list">
             <AnimateOnScroll >
                 <li><a href="#"><span className="ion-ios-checkmark-circle mr-3" />Threading</a></li>
            <li><a href="#"><span className="ion-ios-checkmark-circle mr-3" />Waxing</a></li>
            <li ><a href="#"><span className="ion-ios-checkmark-circle mr-3" />Facial & Packs</a></li>
            <li><a href="#"><span className="ion-ios-checkmark-circle mr-3" />Makeup & Hairstyles</a></li>
            <li><a href="#"><span className="ion-ios-checkmark-circle mr-3" />Mani/Pedi</a></li>
             </AnimateOnScroll>
           
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section className="ftco-gallery ftco-section">
    <div className="container">
      <div className="row justify-content-center mb-5 pb-3">

          <AnimateOnScroll className="col-md-7 heading-section  text-center">
     <h3 className="subheading">Gallery</h3>
          <h2 className="mb-1">See the latest photos</h2>
</AnimateOnScroll>

      </div>

    <div className="row">
 

  
</div>
<Slider {...sliderSettings}>
            {galleryItems.map((url, index) => (
              <div key={index}  className="col-md-12">
                <div  >
                  <a
                    href={url}
                    className="gallery image-popup img d-flex align-items-center"
                    style={{
                      backgroundImage: `url(${url})`,
                      height: '250px',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                     
                     
                    }}
                  >
                    <div className="icon mb-4 d-flex align-items-center justify-content-center">
                      <span className="icon-instagram" />
                    </div>
                  </a>
                </div>
              </div>
            ))}
          </Slider>

    </div>
  </section>
</div>
</>
  );
}
